export const TypeBusinessHourEnum = Object.freeze({
    opened: 'opened',
    closed: 'closed',
    openAllDay: 'openAllDay',
    none: "none"
})